import Enumeration from '@enums/enum';

/**
 * The supported loan types.
 */
export default new Enumeration({
  REFINANCE: 'refinance',
  NEW_LOAN: 'new_loan',
  BUILD: 'build',
});
